import { actionGenerator } from "utils";
import { GET_REMAINING, GET_LIST_WINNER_BY_TYPE } from "./constants";

const actions = {
  GET_REMAINING: actionGenerator.genActions(GET_REMAINING),
  GET_LIST_WINNER_BY_TYPE: actionGenerator.genActions(GET_LIST_WINNER_BY_TYPE),
};

export default actions;
